import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetPrestacionCUMEByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetPrestacionCUMEByUser = () => {
  const [loadingGetPrestacionCUMEByUser, setLoadingGetPrestacionCUMEByUser] = useState(false);
  const [successGetPrestacionCUMEByUser, setSuccessGetPrestacionCUMEByUser] = useState(false);
  const [errorGetPrestacionCUMEByUser, setErrorGetPrestacionCUMEByUser] = useState<any>(null);
  const [dataGetPrestacionCUMEByUser, setDataPrestacionCUMEByUser] = useState<any>(null);

  const [statusGetPrestacionCUMEByUser, setStatusGetPrestacionCUMEByUser] =
    useState<StatusGetPrestacionCUMEByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getPrestacionCUMEByUser = async (
    userId: string, expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetPrestacionCUMEByUser(true);
    setSuccessGetPrestacionCUMEByUser(false);
    setErrorGetPrestacionCUMEByUser(null);

    try {
      const res = await apirecord.getPrestacionEconomicaCUMEByUser(userId, expedienteId);

      setStatusGetPrestacionCUMEByUser({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetPrestacionCUMEByUser(true);
      setDataPrestacionCUMEByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetPrestacionCUMEByUser({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetPrestacionCUMEByUser(err);
      console.error("Error en getPrestacionCUMEByUser:", err);

      throw err;

    } finally {
      setLoadingGetPrestacionCUMEByUser(false);
    }
  };

  return {
    getPrestacionCUMEByUser,
    loadingGetPrestacionCUMEByUser,
    successGetPrestacionCUMEByUser,
    errorGetPrestacionCUMEByUser,
    dataGetPrestacionCUMEByUser,
    statusGetPrestacionCUMEByUser
  };
};

export default useGetPrestacionCUMEByUser;
